<template>
  <div>
    <div class="jifen-header-wrapper">
      <div class="jifen-header">积分设置</div>
      <div class="jifen-change box" >
        <Button type="text" @click="closeChange" v-if="isChange" style="margin-right:10px">取消</Button>
        <Button  :type=btnType @click="changeBtn" :loading="changeLoading">{{isChange?'保存':'编辑'}}</Button>
      </div>
    </div>
    <change-card
      v-if="isChange"
      :jifenRes="jifenRes"
      :changeLoading="changeLoading"
      @closeLoading="closeLoading"
      @submitSuccess="submitSuccess"
    ></change-card>
    <jifen-card v-else :jifenRes="jifenRes" ></jifen-card>
  </div>
</template>

<script>
  var that
  import jifenCard from './components/jifenCard'
  import changeCard from './components/changeJifenCard'
  export default {
    name: "adminJifen",
    components:{
      jifenCard,
      changeCard
    },
    computed: {
      btnType () {
        return this.isChange?'success':'primary'
      }
    },
    data () {
      return {
        isChange: false,//是否为编辑状态  初始 不是
        jifenRes:{},//请求积分详情的结果
        changeLoading:false,
      }
    },
    methods:{
      changeBtn () {
        if (!this.isChange) {
          this.isChange = true
        }else {
          this.changeLoading = true
          // this.isChange = false
        }
      },
      closeChange () {
        this.isChange = false
      },
      //填写信息错误  关闭loading状态
      closeLoading () {
        this.changeLoading = false
      },
      //积分设置成功提交
      submitSuccess () {
        this.changeLoading = false
        this.isChange = false
        this.getJifen()
      },
      getJifen () {
        that.$store.commit("updateSpinShow", true);
        var url = that.urlobj.getJifen
        that.$get(url,{}).then(res => {
          that.$store.commit("updateSpinShow", false);
          var shimingTitle = ''
          var shimingScore = ''
          res.rows.forEach(_item => {
            if (_item.scoreType=="realname") {
              shimingTitle = _item.remark,
              shimingScore = _item.score/100
            }
          })
          this.jifenRes = {
            baifenbi:res.newPrimaryKeys.signPercent?res.newPrimaryKeys.signPercent:'',
            jumin:res.newPrimaryKeys.signPercentResident?res.newPrimaryKeys.signPercentResident:'',
            shimingScore,
            shimingTitle
          }
        }).catch(e => {
          that.$store.commit("updateSpinShow", false);
        })
      }
    },
    mounted () {
      that = this
      that.getJifen()
    },
  }
</script>

<style scoped>
  .jifen-header-wrapper {
    display: flex;
    /*height: 30px;*/
    line-height: 30px;
    padding: 30px 0;
    justify-content: center;
    position: relative;
  }
  .jifen-header {
    font-size: 25px;
    text-align: center;
  }
  .jifen-change {
    position: absolute;
    right: 20px;
  }
</style>
